"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v1Frame = v1Frame;
/**
 * v1's localization frame, which the racquet courts keep and v1's lacrosse
 * volume reuses.
 */
const models_1 = require("../../models");
const courtPoints_1 = require("../../courtPoints");
const features_1 = require("./features");
/**
 * Millimeters, origin at the far-left corner of the lined court, y flipped,
 * calibrated against v1's COURTPOINTS. Physics to localization subtracts the
 * origin, which is bit for bit v1's `p.x + COURT_WIDTH / 2` and
 * `p.y - COURT_LENGTH / 2`.
 */
function v1Frame(sport) {
    const g = models_1.CourtGeometryBySport[sport];
    return {
        localization: { origin: (0, features_1.vec3)(-g.COURT_WIDTH / 2.0, g.COURT_LENGTH / 2.0, 0), flipY: true, unitsPerMeter: 1000.0 },
        referencePoints: Object.fromEntries(Object.entries(courtPoints_1.COURTPOINTS[sport]).map(([name, p]) => [name, (0, features_1.vec3)(p.x, p.y, p.z)])),
    };
}
